import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const ProjectAdminSubContainerStyled = styled(Box)`
  height: 100%;
  border-radius: ${({ theme }) => theme.radii[200]};
  overflow-y: auto;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey[3000]};
`;
